import { getSessionDuration } from 'application/session_duration'

export function clickToggleEvent(data) {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: "click_toggle",
    session_duration: getSessionDuration(),
    module_name: data.module_name,
    click_text: data.click_text,
    field_type: data.field_type,
    event_action: data.event_action
  });
}
